
import React ,{ Component } from 'react';
import {Container, Row, Col,Image,Button,Form,OverlayTrigger,Tooltip  } from 'react-bootstrap';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import "../AttributesCollections/AttributesCollections.css";
import { withRouter,Link } from "react-router-dom";
import { getAPICallDataForOnlyBSA } from '../../services/MemberService'
import loader from '../../images/loader.gif';
import CardLessDataTableWithOutSearch from '../datatables/CardLessDataTableWithOutSearch';
import SelectBox from '../SelectDropDown/SelectDropDown';
import { components } from 'react-select';
import SendWhatsAppMessage from './SendWhatsAppMessage';
import MultiSelect from "react-multi-select-component";
import EnabledLocationPopup from "../Volunteer/EnabledLocationPopup";
import QuestionsSavingPoll from './QuestionsSavingPoll';
import { getAPICallData } from '../../services/MemberService';
import UpdateVoterCaste from './UpdateVoterCaste';

const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
  };
class SendVoterSlipSection extends Component {
    constructor(props) {
        super(props)
        this.state = {
            chatID: window.User !=undefined ? window.User.chatID : "943827154",
            userAccessList:props?.location?.params?.userAccessList == undefined ? "" : props?.location?.params?.userAccessList,
            boothIdValue:"",
            boothId:"",
            boothIdsList:[],
            voterName:"",
            voterCardNo:"",
            houseNo:"",
            partyValue:{'value':'','label':'All'},
            partyId:"",
            partyIdsArr:[{'value':872,'label':'TDP'},{'value':1887,'label':'Others'},{'value':1977,'label':'Not Assigned'}],
            partyseldata: [{'value':872,'label':'TDP'},{'value':1977,'label':'Not Assigned'},{'value':1887,'label':'Others'}],
            partyselvalue: [872,1977,1887],

            isSlipSent:"",
            isVoted:"N",
            isSlipGiven:'',
            isCasteUpdated:'',
            isCasteAssigned:'',
            
            voterDetailsInABoothArr:[],
            votersDataCheckSlip:0,
            votersListSlipLoader:"hide",
            sendWhatsAppMessageModal:false,
            selectedVoterObj:{},
            validateMobileNo:"",
            mobileNoValue:"",
            sendButtonDisabled:false,
            voterSlipLoading:"hide",
            voterSlipMessage:"",
            searchVoterDetailsValue:"",
            messageUrl:"",

            checkingLocationServiceEnabledObj:{},
            checkingEnabledLocationModal:false,

            checkingLocationServiceEnabledPopupObj:{},
            delaylocationModal:false,

            campaignSurveyQuestionnaireArr:null,
            voterVisitedImageCaptureModal:false,

            selectedVoterVisitVoterId:{},
            answerDateTemplateArr:[],
            checkValidationsArr:[],
            checkQuestionsMessage:"",

            checkingLocationServiceVoterObj:{},

            savaCampaignLoadingSymbol:"hide",
            savaCampaignLoadingSuccessMsg:"",
            submitButtonDisabled:false,

            caste_ids_Arr:[{'value':228, 'label':'Aandh '},{'value':326, 'label':'AASADULA '},
                            {'value':75, 'label':'Achukuntla Vandlu '},{'value':312, 'label':'Adi Dravida '},{'value':224, 'label':'AdiAndhra '},{'value':461, 'label':'Agamudayar '},{'value':309, 'label':'Agamudi Mudaliar '},{'value':121, 'label':'Agaru '},{'value':1, 'label':'Agnikula kshathriya '},{'value':199, 'label':'Anamakh '},{'value':200, 'label':'Andhravida '},{'value':122, 'label':'Arae '},{'value':388, 'label':'Arakalies and Surabi natakalavallu '},
                            {'value':201, 'label':'Arapamala '},{'value':347, 'label':'Arava '},{'value':387, 'label':'Are Marathi '},{'value':123, 'label':'Arekatika '},
                            {'value':202, 'label':'Aremala '},{'value':177, 'label':'Arundatheeya '},{'value':329, 'label':'Arwa Mala '},{'value':76, 'label':'Arya Kshathrya '},{'value':124, 'label':'Atagara '},{'value':397, 'label':'Atirasa '},{'value':77, 'label':'Avusala '},
                            {'value':396, 'label':'Ayyaraka '},{'value':2, 'label':'Badar '},{'value':229, 'label':'Bagatha '},{'value':3, 'label':'Balasanthu '},{'value':296, 'label':'Balija '},{'value':467, 'label':'Balija Kapu '},{'value':4, 'label':'Banda '},{'value':5, 'label':'Bandara '},{'value':353, 'label':'Banjara '},{'value':230, 'label':'Barhika Duliya '},{'value':203, 'label':'Barigi '},{'value':125, 'label':'Batraju '},{'value':162, 'label':'Bavuri '},
                            {'value':120, 'label':'BC - C (Cristians) '},{'value':178, 'label':'Bedajangam '},{'value':204, 'label':'Begara '},{'value':442, 'label':'Behar '},{'value':179, 'label':'Bendla '},
                            {'value':449, 'label':'Bengali '},{'value':342, 'label':'Beri Sheety '},{'value':6, 'label':'Bestha '},{'value':391, 'label':'Bhadbhunja '},{'value':7, 'label':'Bhahurupi '},{'value':390, 'label':'Bhunjwa '},{'value':8, 'label':'Bikshaka Vruthi '},{'value':439, 'label':'Biksham Gunta '},{'value':231, 'label':'Bil '},{'value':403, 'label':'Bindla '},{'value':331, 'label':'Binedu '},{'value':416, 'label':'Bodo Gadaba '},{'value':306, 'label':'Bondili '},{'value':293, 'label':'Boya '},{'value':284, 'label':'Brahmin '},{'value':9, 'label':'Buda Bukkala '},{'value':180, 'label':'Budaga Jangam '},{'value':389, 'label':'Budubunjala '},{'value':126, 'label':'Bukka '},{'value':354, 'label':'Bukka Ayyavara '},{'value':404, 'label':'Byagara '},{'value':405, 'label':'Chachati '},{'value':444, 'label':'Chacherlu '},{'value':406, 'label':'Chalavadi '},{'value':205, 'label':'Challavadi '},{'value':181, 'label':'Chamar '},{'value':182, 'label':'Chambar '},{'value':410, 'label':'Chanchandi '},{'value':164, 'label':'Chandala '},{'value':163, 'label':'Chavati '},{'value':232, 'label':'Chenchu Varu '},{'value':233, 'label':'Chenchumuni '},{'value':127, 'label':'Chimpollu '},{'value':78, 'label':'Chithari '},
                            {'value':79, 'label':'Chithrakara '},{'value':445, 'label':'Chitti Karanam '},{'value':11, 'label':'Chopamali '},{'value':459, 'label':'Christian '},{'value':470, 'label':'Converted Harijans '},{'value':183, 'label':'Dakkal/Dakkala Varu '},{'value':355, 'label':'Damala '},{'value':165, 'label':'Dandasi '},{'value':12, 'label':'Dasari (BC-A) '},{'value':128, 'label':'Dasari (BC-D) '},{'value':234, 'label':'Deseeya kondulu '},{'value':235, 'label':'Desiya Dondulu '},{'value':80, 'label':'Devanga '},{'value':13, 'label':'Devara Vandlu '},{'value':184, 'label':'Dhor '},{'value':423, 'label':'Dhulia '},{'value':167, 'label':'DomDombara '},{'value':14, 'label':'Dommara '},{'value':236, 'label':'Dondra Kodulu '},{'value':81, 'label':'Dudekula '},{'value':82, 'label':'Ediga '},{'value':321, 'label':'EKILA '},{'value':352, 'label':'Ekiri '},{'value':15, 'label':'Ellamma Vandlu '},{'value':16, 'label':'Ellasi '},{'value':345, 'label':'Erla '},{'value':237, 'label':'Gadabalu '},{'value':415, 'label':'Gadabas '},{'value':129, 'label':'Gadava '},{'value':318, 'label':'Gajula Balija '},{'value':83, 'label':'Gamalla Kalali '},{'value':84, 'label':'Gandla '},{'value':18, 'label':'Ganga Varu '},{'value':17, 'label':'Gangaputhra '},{'value':19, 'label':'Gangireddu Varu '},{'value':340, 'label':'Ganuga Sheety '},{'value':168, 'label':'Gasi '},{'value':130, 'label':'Gavara '},{'value':407, 'label':'Ghasi '},{'value':131, 'label':'Ginghar '},{'value':85, 'label':'Giniyar '},{'value':170, 'label':'Godagali '},{'value':185, 'label':'Godari '},{'value':20, 'label':'Gondlu '},{'value':238, 'label':'Gondu '},{'value':206, 'label':'Gosam '},{'value':411, 'label':'Gosangi '},{'value':357, 'label':'Gotrala '},{'value':239, 'label':'Goud-ST '},{'value':86, 'label':'Gouda '},{'value':240, 'label':'Goudh '},{'value':87, 'label':'Goundla '},{'value':21, 'label':'Gudala '},{'value':392, 'label':'Gudia '},{'value':393, 'label':'Gudiya '},{'value':417, 'label':'Gutob Gadaba '},{'value':408, 'label':'Haddi '},
                            {'value':169, 'label':'Haddi (or) Relli chachandi '},{'value':446, 'label':'Harijans '},{'value':132, 'label':'Hatkhar '},{'value':419, 'label':'Hill Reddis '},{'value':207, 'label':'Huleya '},{'value':208, 'label':'Huleya Dasari '},{'value':186, 'label':'Jaggali '},{'value':412, 'label':'JaJnbllvulu '},{'value':332, 'label':'Jakkula '},{'value':22, 'label':'Jalari '},
                            {'value':187, 'label':'Jambavulu '},{'value':88, 'label':'Jandra '},{'value':23, 'label':'Jangam '},{'value':241, 'label':'Jathapass '},{'value':24, 'label':'Jogi '},{'value':341, 'label':'Jogula '},{'value':25, 'label':'Joshinandala Bala '},{'value':133, 'label':'Kachi '},{'value':26, 'label':'Kaikadi '},{'value':89, 'label':'Kaikala '},{'value':438, 'label':'Kaitha Lambadi(Labhana) '},
                            {'value':134, 'label':'Kakkana '},{'value':335, 'label':'Kalai Balija '},{'value':135, 'label':'Kalavanthulu Ganika '},{'value':324, 'label':'KALINGA '},{'value':440, 'label':'Kalinga Vysya '},{'value':418, 'label':'kallayi gadaba '},{'value':27, 'label':'Kalli Kapu '},{'value':290, 'label':'Kamma '},{'value':90, 'label':'Kammara (BC) '},{'value':242, 'label':'Kammara (ST) '},{'value':91, 'label':'Kamsali/Vishva Bramhana '},{'value':92, 'label':'Kanchra '},{'value':136, 'label':'Kandhra '},{'value':28, 'label':'Kanjara Battu '},{'value':288, 'label':'Kapu '},{'value':466, 'label':'Kapu Kapu '},{'value':469, 'label':'Kapu-ST '},{'value':304, 'label':'KARANAM '},{'value':323, 'label':'KARIKALABHAKTHULA '},{'value':93, 'label':'Karna Bakthulu '},{'value':322, 'label':'KARNABHAKTHULA '},{'value':358, 'label':'Kasikapadi '},{'value':94, 'label':'Kathri '},{'value':29, 'label':'Kati Papala '},{'value':243, 'label':'Katunaikan '},{'value':333, 'label':'Kavali '},{'value':431, 'label':'Kerala '},{'value':359, 'label':'Keuta '},{'value':360, 'label':'Keviti '},{'value':361, 'label':'Kevuto '},{'value':30, 'label':'Kinthala Kalinga '},{'value':31, 'label':'Kirathaka '},{'value':244, 'label':'Kodhu '},{'value':245, 'label':'Kodi '},{'value':420, 'label':'Kolam '},{'value':421, 'label':'Kolawar '},{'value':188, 'label':'Koluvula Vandlu '},{'value':32, 'label':'Kompara/Reddika '},{'value':246, 'label':'Konda Doralu '},{'value':247, 'label':'Konda Kapulu '},{'value':248, 'label':'Konda Reddlu '},{'value':250, 'label':'Kondlu '},{'value':137, 'label':'Koppula Velama '},{'value':251, 'label':'Koputiya '},{'value':252, 'label':'Koram '},{'value':33, 'label':'Korcha '},{'value':138, 'label':'Kosti '},{'value':433, 'label':'Kotiya '},{'value':253, 'label':'Kotiya Benthu '},{'value':254, 'label':'Koya '},{'value':139, 'label':'Krushna Balija '},{'value':34, 'label':'Kshathriya (BC) '},{'value':291, 'label':'Kshatriya (OC) '},{'value':255, 'label':'Kuliya '},{'value':256, 'label':'Kulwalapai '},{'value':95, 'label':'Kummara '},{'value':35, 'label':'Kunapuli '},{'value':429, 'label':'Kunkuma '},{'value':475, 'label':'Kuraba '},{'value':362, 'label':'Kurakala '},{'value':382, 'label':'Kurni '},
                            {'value':96, 'label':'Kuruma '},{'value':257, 'label':'Kuttiya Kodulu '},{'value':317, 'label':'Labbai '},{'value':97, 'label':'Laddaf '},{'value':402, 'label':'Lakkamari Kapu '},{'value':363, 'label':'Lambada '},{'value':258, 'label':'Lambadi '},{'value':313, 'label':'Lingayat '},{'value':384, 'label':'Lodh '},{'value':386, 'label':'Lodha '},{'value':385, 'label':'Lodhi '},{'value':189, 'label':'Madiga '},{'value':190, 'label':'Madiga Dasu '},{'value':209, 'label':'Madisi Kuruva/Madaari Kuruva '},{'value':210, 'label':'Mahar '},{'value':36, 'label':'Mahathar '},{'value':211, 'label':'Mala '},{'value':212, 'label':'Mala Dasari '},{'value':213, 'label':'Mala Hannai '},{'value':214, 'label':'Mala Jangam '},{'value':216, 'label':'Mala Masthi '},{'value':217, 'label':'Mala Sala '},{'value':218, 'label':'Mala sanyasi '},{'value':427, 'label':'Maladasu '},{'value':140, 'label':'Mali '},{'value':259, 'label':'Malin '},{'value':37, 'label':'Mandala (BC) '},{'value':219, 'label':'Mandala (SC) '},{'value':364, 'label':'Mandula '},{'value':191, 'label':'Mang Garodi '},{'value':192, 'label':'Manga '},{'value':260, 'label':'Manna Dora '},{'value':220, 'label':'Manne '},{'value':448, 'label':'Mannepu '},{'value':261, 'label':'Mannevaru '},{'value':315, 'label':'MARATI '},{'value':330, 'label':'MARWADI '},{'value':225, 'label':'Masthi '},{'value':193, 'label':'Masthima '},{'value':194, 'label':'Mathangi '},{'value':262, 'label':'Mathaya Vavaras (or) Kuttu Vavaras '},{'value':141, 'label':'Mathula '},{'value':305, 'label':'MAYDARA '},{'value':39, 'label':'Medari '},{'value':171, 'label':'Mehthar '},{'value':319, 'label':'Mera Darji '},{'value':226, 'label':'Mitha Iyala Varu '},{'value':195, 'label':'Mochi '},{'value':301, 'label':'Mohamad '},{'value':40, 'label':'Mondi Banda '},{'value':41, 'label':'Mondi Varu '},{'value':42, 'label':'Mondipatta '},{'value':196, 'label':'Moochi '},{'value':98, 'label':'Muchi '},{'value':460, 'label':'Mudaliar '},{'value':143, 'label':'Mudhiraj '},{'value':263, 'label':'Muka Dora '},{'value':314, 'label':'MUNDALA '},{'value':144, 'label':'Munnoor Kapu '},{'value':292, 'label':'Muslim '},{'value':145, 'label':'Mutharasi '},{'value':43, 'label':'Muthyalamma Vandlu '},{'value':428, 'label':'Myralu '},{'value':451, 'label':'N/A '},{'value':348, 'label':'Nadar '},{'value':435, 'label':'Nagaralu '},{'value':99, 'label':'Nagavaddilu '},{'value':146, 'label':'Nagavamsha '},{'value':147, 'label':'Nagavasam '},{'value':264, 'label':'Naik '},{'value':265, 'label':'Naikpoth '},{'value':100, 'label':'Nakhan '},{'value':44, 'label':'Nakkala '},{'value':349, 'label':'Nambi '},
                            {'value':45, 'label':'Nashadi '},{'value':101, 'label':'Nashni/Kurni '},{'value':307, 'label':'Natari '},{'value':426, 'label':'Nayaka '},{'value':344, 'label':'Nayani Varu '},{'value':365, 'label':'Nayanivaru '},{'value':38, 'label':'Nayee Brahmin '},{'value':47, 'label':'Nayyala '},{'value':102, 'label':'Neelikanti '},{'value':148, 'label':'Nelli '},{'value':325, 'label':'NEPALI '},{'value':48, 'label':'Nera Pravruthi Kalavaru '},{'value':49, 'label':'Nershakari '},{'value':381, 'label':'Nessi '},{'value':447, 'label':'Nethekani '},{'value':50, 'label':'Nokkara '},{'value':432, 'label':'Nooka Dora '},{'value':298, 'label':'Oreganti Reddy '},{'value':458, 'label':'OTHERS '},{'value':472, 'label':'OTHERS-BC '},{'value':471, 'label':'OTHERS-OC '},{'value':473, 'label':'OTHERS-SC '},{'value':474, 'label':'OTHERS-ST '},{'value':103, 'label':'Padmashali '},{'value':166, 'label':'Paidi/pano '},
                            {'value':424, 'label':'Paiko '},{'value':172, 'label':'Paki (or) Mothi '},{'value':366, 'label':'Pala Ekari '},{'value':367, 'label':'Palegaru '},{'value':300, 'label':'Pallepu Kapu '},{'value':310, 'label':'Palli '},{'value':343, 'label':'Palli Kapu '},{'value':346, 'label':'Palli Reddy '},{'value':51, 'label':'Pambala '},{'value':174, 'label':'Pamidi '},{'value':52, 'label':'Pamula '},{'value':227, 'label':'Panchama (or) Pariyuhi '},{'value':450, 'label':'Panda '},{'value':150, 'label':'Panjari '},{'value':53, 'label':'Pannari '},{'value':266, 'label':'Parangi Parcha '},{'value':422, 'label':'Pardhan '},{'value':54, 'label':'Parthi '},{'value':151, 'label':'Paspi '},{'value':395, 'label':'Passi '},{'value':303, 'label':'Pathan '},{'value':104, 'label':'Patkhar '},{'value':55, 'label':'Patlavu '},{'value':436, 'label':'Patnayak '},{'value':434, 'label':'Patnayak '},{'value':316, 'label':'PATRA '},{'value':299, 'label':'Pattapu '},{'value':454, 'label':'Pattusali '},{'value':56, 'label':'Peddaboya '},{'value':57, 'label':'Peddama Vandlu '},{'value':105, 'label':'Perika '},{'value':106, 'label':'Perika Balija '},{'value':107, 'label':'Pinjari/Noorbash '},{'value':59, 'label':'Piriki Muggula '},{'value':58, 'label':'Pitchiguntla '},{'value':152, 'label':'Polinati Velama '},{'value':368, 'label':'Pondara '},{'value':153, 'label':'Poosala '},{'value':369, 'label':'Poosala '},{'value':267, 'label':'Porja '},{'value':60, 'label':'Porvam Bikshaka Vruthi '},{'value':462, 'label':'Pusala '},{'value':425, 'label':'Putiya '},{'value':61, 'label':'Rajaka '},{'value':370, 'label':'Rajannala '},{'value':334, 'label':'Rajput '},{'value':289, 'label':'Raju '},{'value':268, 'label':'Rajugondu '},{'value':154, 'label':'Rangaraju/Bhavasara Kshatriya '},
                            {'value':441, 'label':'Ravula '},{'value':285, 'label':'Reddy '},{'value':269, 'label':'Reddy Dora '},{'value':465, 'label':'Reddy Kapu '},{'value':468, 'label':'Reddy Reddy '},{'value':175, 'label':'Relli '},{'value':270, 'label':'Rona Rena '},{'value':443, 'label':'Sabeerlu '},{'value':452, 'label':'Sadara '},{'value':155, 'label':'Sadushetti '},{'value':371, 'label':'Saikalgar '},{'value':108, 'label':'Sakulasali '},{'value':197, 'label':'Samagara '},{'value':372, 'label':'Samanthula '},{'value':221, 'label':'Samband '},{'value':222, 'label':'Sambas '},{'value':271, 'label':'Sandrona '},{'value':109, 'label':'Sangundam '},{'value':176, 'label':'Sapru '},{'value':272, 'label':'Sardhan '},{'value':156, 'label':'Sathani '},{'value':273, 'label':'Savaras Kapusavaras '},{'value':311, 'label':'Seervi '},{'value':110, 'label':'Settibalija '},{'value':111, 'label':'Shilpi '},{'value':373, 'label':'Siddula '},{'value':274, 'label':'Sidopaiko '},{'value':430, 'label':'Sikh '},{'value':374, 'label':'Sikligar '},{'value':383, 'label':'Silpis viswakarma '},{'value':198, 'label':'Sindollu '},{'value':351, 'label':'Singh '},{'value':401, 'label':'Sistakaranam '},{'value':398, 'label':'sondi '},{'value':375, 'label':'Sountia '},{'value':112, 'label':'Sri Sayan '},{'value':275, 'label':'Sugaleelu '},{'value':399, 'label':'sundi '},{'value':394, 'label':'Surya Balija '},{'value':339, 'label':'Suryavamsha Rajulu '},{'value':302, 'label':'Syed '},{'value':328, 'label':'Telaga '},{'value':350, 'label':'Telikula '},{'value':113, 'label':'Telugu Matlade Varu '},{'value':114, 'label':'Thalikula '},{'value':157, 'label':'Thammali '},{'value':158, 'label':'Thenugollu '},{'value':276, 'label':'Thikakariya Kodulu '},{'value':115, 'label':'Thogati Thogata '},{'value':173, 'label':'Thoti (BC) '},{'value':277, 'label':'Thoti (ST) '},{'value':159, 'label':'Thurapu Kapu/Gajula Kapu '},{'value':376, 'label':'Tolagari '},{'value':160, 'label':'Uppara/Sankara '},{'value':338, 'label':'Uppu vadde '},{'value':377, 'label':'Vadabalija '},{'value':283, 'label':'Vaddera '},{'value':62, 'label':'Vaddi '},{'value':63, 'label':'Vaddolu '},{'value':116, 'label':'Vadla '},{'value':117, 'label':'Vadra '},{'value':118, 'label':'Vadrangi '},{'value':64, 'label':'Valli '},{'value':65, 'label':'Valli Reddy '},{'value':414, 'label':'Valluvan '},{'value':278, 'label':'Valmiki '},{'value':378, 'label':'Valmiki '},{'value':66, 'label':'Valmiki Boya '},{'value':455, 'label':'Vamsharaj '},{'value':437, 'label':'Vanjari '},{'value':67, 'label':'Vanne Kapu '},{'value':68, 'label':'Vanne Reddy '},{'value':336, 'label':'Vannekapu '},{'value':308, 'label':'Vanyakulakshatriya '},{'value':400, 'label':'varala '},{'value':69, 'label':'Vatti Kothala '},{'value':70, 'label':'Vedabaliga '},
                            {'value':379, 'label':'Veerabhadreeya '},{'value':327, 'label':'Veerashaiva LingayatLingabalija '},{'value':287, 'label':'Velama '},{'value':71, 'label':'Venka Kula '},{'value':72, 'label':'Vera Musti '},{'value':73, 'label':'Vodde Yeddelu '},{'value':453, 'label':'Vokkaliga '},{'value':279, 'label':'Voriya/bentu Voriya '},{'value':380, 'label':'Vyakula '},{'value':286, 'label':'Vysya '},{'value':161, 'label':'Yadava '},{'value':337, 'label':'Yalam Reddy '},{'value':74, 'label':'Yata '},{'value':413, 'label':'Yatala '},{'value':223, 'label':'Yellimal Varu '},{'value':280, 'label':'Yenadi '},{'value':281, 'label':'Yerukala '},{'value':282, 'label':'Yoniti Kodulu'}],
            casteIdStr:"",
            casteIdStrValue:"",

            updateVoterCasteLoading:"hide",
            updateVoterCasteMessage:"",
            disabledButtonCaste:false,
            UpdateVoterCasteModalShow:false,
            selectedVoterCasteIds:{},
            validateCasteName:""
        }
    }

    componentDidMount() {
        console.log("userAccessList",this.state.userAccessList)
        if(this.state.userAccessList == ""){
            this.props.history.push("/dashboard");
        }else{

            if(this.state.chatID != "1048868711"){
                if(navigator.geolocation){
                    navigator.geolocation.getCurrentPosition(this.checkingLocationServiceEnabledPopup,this.checkingLocationServiceEnabledError)
                }else{
                    <EnabledLocationPopup 
                        show={() => this.setState({ checkingEnabledLocationModal: true })}
                        onHide={() => this.setState({ checkingEnabledLocationModal: false })}
                        closeEnabledModal={this.closeEnabledModal}
                    />
                }
                setTimeout(() => this.setState({delaylocationModal:true}), 2000);
             }

            if(this.state.userAccessList.boothList != null && this.state.userAccessList.boothList.length>0){
                let arr=[];
                this.state.userAccessList.boothList.map(item => {
                    const obj = {
                        value: item.id,
                        label: "Booth No -"+item.name,
                    }
                    arr.push(obj);
                    
                });
                this.setState({ boothIdsList: arr });
                
                
            }

            this.getCampaignSurveyQuestionnaire();
        }

        
    }

    getCampaignSurveyQuestionnaire = () => {
        const obj =  
        JSON.stringify({ 
            "chatId" :this.state.chatID,
            "campaignId" : 6,
        });
    
    

    getAPICallData(obj,"CampaignEnrollment/getCampaignSurveyQuestionnaire")
        .then((res) => res.json())
        .then((content) => {
            if(content !=null && content.length>0){
                this.setState({campaignSurveyQuestionnaireArr:content});
            }else{
                this.setState({campaignSurveyQuestionnaireArr:[]});
            }
        });
    }

    checkingLocationServiceEnabledPopup = (position) => {
        const getCoordinates =  
            { 
            "latitude" : position.coords.latitude,
            "longitude" : position.coords.longitude,
            "accuracy":position.coords.accuracy
            }
            
        this.setState({checkingLocationServiceEnabledPopupObj:getCoordinates});
    }

    handleOnchangeSelectBoxNew = (ename, evalue) =>{
        const name = ename;
        const value = evalue;
    
        if(name == "boothId"){
          let boothIdName = this.state.boothIdsList.find((a) => a.value == value);
            this.setState({
                boothIdValue: {
                  value: boothIdName.value,
                  label: boothIdName.label
              }
          });
    
          this.setState({ boothId: value});
        
        
        }else if(name == "casteIdStr"){
            let casteIdName = this.state.caste_ids_Arr.find((a) => a.value == value);
            this.setState({
                casteIdStrValue: {
                  value: casteIdName.value,
                  label: casteIdName.label
              }
          });

    
          this.setState({ casteIdStr: value});
        }/*else if(name == "partyId"){
            let partyIdName = this.state.partyIdsArr.find((a) => a.value == value);
            this.setState({
                partyValue: {
                  value: partyIdName.value,
                  label: partyIdName.label
              }
          });

    
          this.setState({ partyId: value});
        }*/
    }

    checkIsCasteAssigned = (e,value) => {
        this.setState({isCasteAssigned:value})
    }

    checkIsCasteUpdated = (e,value) => {
        this.setState({isCasteUpdated:value})
    }

    checkIsVoterSearch = (e,value) => {
        this.setState({isVoted:value})
        
    }
    checkIsVoterSlipSent = (e,value) => {
        this.setState({isSlipSent:value})
        
    }

    checkIsVoterSlipGivenSent = (e,value) => {
        this.setState({isSlipGiven:value})
    }

    getVoterDetailsInABooth = () => {
        this.setState({validateboothId:"",voterDetailsInABoothArr:[],votersDataCheckSlip:0});
        
        if(this.state.boothId == "" || this.state.boothId == 0){
            this.setState({validateboothId:"Please Select Booth"});
            return;
        }

        var isSlipSentVal = "";
        var isVotedVal = "";
        var isSlipGivenVal = "";
        var isCasteUpdatedval = "";

        if(this.state.isSlipSent == 'N'){
            isSlipSentVal = '';
        }else{
            isSlipSentVal = this.state.isSlipSent
        }

        if(this.state.isVoted == 'N'){
            isVotedVal = '';
        }else{
            isVotedVal = this.state.isVoted
        }

        if(this.state.isCasteUpdated == 'N'){
            isCasteUpdatedval = '';
        }else{
            isCasteUpdatedval = this.state.isCasteUpdated
        }

        if(this.state.isSlipGiven == 'N'){
            isSlipGivenVal = '';
        }else{
            isSlipGivenVal = this.state.isSlipGiven
        }

        this.setState({votersListSlipLoader:"show"})
        const obj =  
            JSON.stringify({ 
                "chatId" :this.state.chatID,
                "boothId" : this.state.boothId,
                "voterCardNo" : this.state.voterCardNo,
                "voterName" : this.state.voterName,
                "houseNo" : this.state.houseNo,
                "partyIds" : this.state.partyselvalue,
                "isVoted" : isVotedVal,
                "isSlipSent" :isSlipSentVal,
                "isSlipGiven" :isSlipGivenVal,
                "isCasteUpdated ":isCasteUpdatedval,
                "isCasteAssigned":this.state.isCasteAssigned
            });
        
            getAPICallData(obj,"getVoterDetailsInABooth")
            .then((res) => res.json())
            .then((content) => {
                this.setState({votersListSlipLoader:"hide"});

                if(content !=null && content.length>0){
                    var dataArr=[];

                   /* if(this.state.isSlipSent == 'N' && this.state.isVoted == '' && this.state.isSlipGiven == 'N'){
                        dataArr = content.filter((item) => item.isSlipSent != 'Y' && item.isSlipGiven != 'Y');
                    }else if(this.state.isSlipSent == 'N' && this.state.isVoted == 'N' && this.state.isSlipGiven == 'N'){
                        dataArr = content.filter((item) => item.isSlipSent != 'Y' && item.isVoted != 'Y' && item.isSlipGiven != 'Y');
                    }else if(this.state.isSlipSent == '' && this.state.isVoted == 'N' && this.state.isSlipGiven == ''){
                        dataArr = content.filter((item) => item.isVoted != 'Y' && item.isSlipSent != 'Y' && item.isSlipGiven != 'Y');
                    }else if(this.state.isSlipSent == 'Y' && this.state.isVoted == 'N' && this.state.isSlipGiven == 'Y'){
                        dataArr = content.filter((item) => item.isVoted != 'Y' && item.isSlipSent == 'Y' && item.isSlipGiven == 'Y');
                    }else if(this.state.isSlipSent == 'N' && this.state.isVoted == 'Y' && this.state.isSlipGiven == 'Y'){
                        dataArr = content.filter((item) => item.isVoted == 'Y' && item.isSlipSent != 'Y' && item.isSlipGiven == 'Y');
                    }else if(this.state.isSlipSent == 'Y' && this.state.isVoted == 'N' && this.state.isSlipGiven == 'N'){
                        dataArr = content.filter((item) => item.isVoted != 'Y' && item.isSlipSent == 'Y' && item.isSlipGiven != 'Y');
                    }else if(this.state.isSlipSent == 'Y' && this.state.isVoted == 'Y' && this.state.isSlipGiven == 'N'){
                        dataArr = content.filter((item) => item.isVoted == 'Y' && item.isSlipSent == 'Y' && item.isSlipGiven != 'Y');
                    }else{
                        dataArr = content;
                    }*/


                    if(this.state.isVoted == '' && this.state.isCasteUpdated == ''){
                        dataArr = content;
                    }else if(this.state.isVoted == '' && this.state.isCasteUpdated == 'Y'){
                        dataArr = content.filter((item) => item.isCasteUpdated == 'Y');
                    }else if(this.state.isVoted == '' && this.state.isCasteUpdated == 'N'){
                        dataArr = content.filter((item) => item.isCasteUpdated != 'Y');
                    }else if(this.state.isVoted == 'N' && this.state.isCasteUpdated == ''){
                        dataArr = content.filter((item) => item.isVoted != 'Y');
                    }else if(this.state.isVoted == 'N' && this.state.isCasteUpdated == 'N'){
                        dataArr = content.filter((item) => item.isVoted != 'Y' && item.isCasteUpdated != 'Y');
                    }else if(this.state.isVoted == 'N' && this.state.isCasteUpdated == 'Y'){
                        dataArr = content.filter((item) => item.isVoted != 'Y' && item.isCasteUpdated == 'Y');
                    }else if(this.state.isVoted == 'Y' && this.state.isCasteUpdated == ''){
                        dataArr = content.filter((item) => item.isVoted == 'Y');
                    }else if(this.state.isVoted == 'Y' && this.state.isCasteUpdated == 'N'){
                        dataArr = content.filter((item) => item.isVoted == 'Y' && item.isCasteUpdated != 'Y');
                    }else if(this.state.isVoted == 'Y' && this.state.isCasteUpdated == 'Y'){
                        dataArr = content.filter((item) => item.isVoted == 'Y' && item.isCasteUpdated == 'Y');
                    }else{
                        dataArr = content[0];
                    }

                    this.setState({voterDetailsInABoothArr:dataArr,votersDataCheckSlip:0});
                }else if(content !=null && content.message == "Authentication Failed"){
                    this.setState({voterDetailsInABoothArr:[],votersDataCheckSlip:2});
                }else{
                    this.setState({voterDetailsInABoothArr:[],votersDataCheckSlip:1});
                }
            });
    }

    sortFuncSerialNo(a, b, order, dataField, rowA, rowB)  { 
        if (order == 'desc') {
            
            return parseInt(rowB.Serial_No)  > parseInt(rowA.Serial_No) ? 1 : -1;

        } else {
            return parseInt(rowA.Serial_No)  > parseInt(rowB.Serial_No) ? 1 : -1;
        }
    }

    voterSlipSendDisplayColumns() {
        let columns = [
            
            
            {
                dataField: "Serial_No",
                text: "S:No",
                sort: true,
                sortFunc: this.sortFuncSerialNo.bind(this),
                headerStyle: {
                    width: "10%"
                }
                
                
            },
            {
                dataField: "voter_Name",
                text: "Name",
                formatter: this.actionsFormatterForVoterSlipName.bind(this),
                headerStyle: {
                    width: "35%"
                }
                
            },
            
            /*{
                dataField: "physical",
                text: "Phy Voter Slip/Manifesto",
                headerStyle: {
                    width: "30%"
                },
                formatter: this.actionsFormatterForVotedGiven.bind(this),
            
            }*/,
            {
                dataField: "poll_vote",
                text: "Which party Voted",
                formatter: this.actionsFormatterForPolledVotes.bind(this),
                headerStyle: {
                    width: "20%"
                }
                
            },
            {
                dataField: "is_voted",
                text: "Is Voted",
                formatter: this.actionsFormatterForVoted.bind(this),
                headerStyle: {
                    width: "30%"
                }
                
            }
            /*{
                dataField: "send",
                text: "Digital Voter Slip",
                headerStyle: {
                    width: "25%"
                },
                formatter: this.actionsFormatterForSendVoterSlip.bind(this),
            
             }*/
        
        ];
        return columns;
    }

    actionsFormatterForVoterSlipName = (cell, row, rowIndex, formatExtraData) => {
      
        return (
            <>
            <span style={{textAlign:"left",marginLeft:"0px"}}>{(row.voter_Name)} 
                <><br/><span className='f-10 color_red' style={{textAlign:"left",marginLeft:"0px"}}>VCN - {(row.voterCardNo)}</span></>
                <><br/><span className='f-10 ' style={{textAlign:"left",marginLeft:"0px"}}>Gender - {(row.GNR)} , Age - {(row.Age)} </span></>
                {
                    row.mobileNo != '' ?
                    (<><br/><span className='color_red' style={{textAlign:"left",marginLeft:"0px"}}><a href={`tel:+91${row.inchargeMobile}`} target='_blank'><span className='f-12' style={{textAlign:"left",marginLeft:"0px"}}><i class="fa-solid fa-phone"></i> {(row.mobileNo)}</span></a> </span></>)
                    :
                    ("")
                }
                
                <><br/><span className='f-10 ' style={{textAlign:"left",marginLeft:"0px"}}>HouseNo - {(row.houseNo)}</span></>
                <><br/><span className='f-10 ' style={{textAlign:"left",marginLeft:"0px"}}>RN - {(row.relectiveName)}</span></>
                <><br/><span className='f-10 ' style={{textAlign:"left",marginLeft:"0px"}}>Relation - {(row.relation)}</span></>
                <><br/><span className='f-12 fw-bold' style={{textAlign:"left",marginLeft:"0px"}}>Caste - {(row.casteName)}</span></>
            </span>

            <Row>
                <Col>
                    {
                        row.isCasteUpdated == "Y" ?
                        (<h6 className='f-12 mt-2 text-center cursor_pointer fw-bold text-decoration-underline color_green' onClick={() => this.voterCasteUpdateModal(row)}>Update Caste</h6>)
                        :
                        (<h6 className='f-12 mt-2 text-center cursor_pointer fw-bold text-decoration-underline color_red' onClick={() => this.voterCasteUpdateModal(row)}>Update Caste</h6>)
                    }
                    
                </Col>
            </Row>
            </>
         );
        
    }

    actionsFormatterForSendVoterSlip = (cell, row, rowIndex, formatExtraData) => {
        return (
            <>
                <Button type="button" className='btn btn-sm btn-success f-10 fw-bold whatsApp_pad' onClick={() => this.sendVoterSlipViaWhatsAppMessageModal(row,"sendVoterSlipViaWhatsAppMessage")} >
                    WhatsApp 
                </Button>
                

                <Button type="button" className='btn btn-sm btn-danger f-10 fw-bold mt-2 sms_pad' onClick={() => this.sendVoterSlipViaWhatsAppMessageModal(row,"sendVoterSlipViaMobileMessage")} >
                 SMS
                </Button>

                {
                    row.isSlipSent == 'Y' ?
                    (<h6 className='f-12 text-center mt-3'>Slip Sent <i class="fa-solid fa-circle-check color_green"></i></h6>)
                    :
                    ("")
                }
                

                
            </>
         );
    }

    actionsFormatterForVotedGiven = (cell, row, rowIndex, formatExtraData) => {
        return (
            <>
               <Row>
                    <Col>
                        <Form>
                            
                            <div className=''>
                                {
                                    row.isSlipGiven == 'Y' ?
                                    (
                                        <Form.Check
                                            inline
                                            label={`Given`}
                                            id={`yesGiven-${row.voterId}`}
                                            type="checkbox"
                                            onChange={(e)=>this.updateVoterSlipGivenStatus(e,row.voterId,'Y')}
                                            className="f-12  color_black isVoteChecked"
                                            value="Y"
                                            defaultChecked={true}
                                        />
                                    )
                                    :
                                    (
                                        <Form.Check
                                            inline
                                            label={`Given`}
                                            id={`yesGiven-${row.voterId}`}
                                            type="checkbox"
                                            onChange={(e)=>this.updateVoterSlipGivenStatus(e,row.voterId,'Y')}
                                            className="f-12  color_black isVoteChecked"
                                            value="Y"
                                        />
                                    )
                                }
                            
                            {/*<Form.Check
                                inline
                                label={`No`}
                                name={`IsVoter${row.voterId}}`}
                                id={`no-${row.voterId}}`}
                                type="radio"
                                onChange={(e)=>this.checkIsVoterSlipSent(e,"Y")}
                                className="f-14 color_black"
                                value="N"
                            />*/}
                            
                            </div>
                        </Form> 
                        <h6 className='color_red f-10 fw-bold mt-2' id={`loadingSymbolIsGivenVoted${row.voterId}`}></h6> 
                        <h6 className='color_green f-12 fw-bold mt-2' id={`messageDisplayGiven${row.voterId}`}></h6> 
                    </Col>
                </Row>
            </>
        )
    }

    actionsFormatterForVoted = (cell, row, rowIndex, formatExtraData) => {
        console.log("row.isVoted",row.checkedCondition+"-"+row.isVoted)   
        return (
            <>
               <Row>
                    <Col>
                    {
                        row.isVoted == '' ?
                        (
                            <div className='flex-align-radiobuttons'>
                            <div className=''>
                                <input type="radio" 
                                    className='f-14 m-lr' 
                                    name={row.voterCardNo} 
                                    id={"yes"+row.voterId} 
                                    value="Y"
                                    onChange={(e)=>this.updateVoterPollingStatus(e,row.voterId,'Y')}
                                />
                                <label htmlFor={"yes"+row.voterId} className='f-14 color_black cursor_pointer'>Yes</label>
                            </div>
                            <div className=''>
                                <input type="radio" 
                                    className='f-14 m-lr' 
                                    name={row.voterCardNo} 
                                    id={"no"+row.voterId} 
                                    value="N"
                                    onChange={(e)=>this.updateVoterPollingStatus(e,row.voterId,'N')}
                                />
                                <label  htmlFor={"no"+row.voterId} className='f-14 color_black cursor_pointer'>No</label>
                            </div>
                        </div>
                        )
                        :
                        (
                            <div className='flex-align-radiobuttons'>
                            <div className=''>
                                <input type="radio" 
                                    className='f-14 m-lr' 
                                    name={row.voterCardNo} 
                                    defaultChecked={row.isVoted == "Y" ? true : false}
                                    id={"yes"+row.voterId} 
                                    value="Y"
                                    onClick={(e)=>this.updateVoterPollingStatus(e,row.voterId,'Y')}
                                    
                                />
                                <label htmlFor={"yes"+row.voterId} className='f-14 color_black cursor_pointer'>Yes</label>
                            </div>

                            {
                                row.isVoted == 'Y' ?
                                (
                                    <div className=''>
                                        <input type="radio" 
                                            className='f-14 m-lr' 
                                            name={row.voterCardNo} 
                                            id={"no"+row.voterId} 
                                            value="N"
                                            onClick={(e)=>this.updateVoterPollingStatus(e,row.voterId,'N')}
                                            
                                        />
                                        <label  htmlFor={"no"+row.voterId} className='f-14 color_black cursor_pointer'>No</label>
                                    </div>
                                )
                                :
                                (
                                    <div className=''>
                                        <input type="radio" 
                                            className='f-14 m-lr' 
                                            name={row.voterCardNo} 
                                            defaultChecked={row.isVoted == "N" ? true : false}
                                            id={"no"+row.voterId} 
                                            value="N"
                                            onClick={(e)=>this.updateVoterPollingStatus(e,row.voterId,'N')}
                                            
                                        />
                                        <label  htmlFor={"no"+row.voterId} className='f-14 color_black cursor_pointer'>No</label>
                                    </div>
                                )
                            }
                            
                        </div>
                        )
                    }
                        
                        
                        
                    
                    </Col>
                    
                    </Row>
                    
                    <Row>
                        <Col className='mt-3'>
                            <span className='isVoteChecked'>
                                <input type="radio" 
                                    className='f-12' 
                                    name={row.voterCardNo} 
                                    id={"cancel"+row.voterId} 
                                    value=""
                                    onChange={(e)=>this.updateVoterPollingStatus(e,row.voterId,'')}
                                />
                                <label  htmlFor={"cancel"+row.voterId} className='f-12 color_black cursor_pointer'>Cancel</label>
                            </span>
                                
                            </Col>
                    </Row>

                    <Row>
                        <Col>
                            <h6 className='color_red f-10 fw-bold mt-2' id={`loadingSymbolIsVoted${row.voterId}`}></h6> 
                            <h6 className='color_green f-12 fw-bold mt-2' id={`messageDisplay${row.voterId}`}></h6> 
                        </Col>
                    </Row>
            </>
        )
    }

    actionsFormatterForPolledVotes = (cell, row, rowIndex, formatExtraData) => {
        return (
            <>
                {
                    row.isExitPolled == 'Y' ?
                    (
                        <>
                        <h6 className='color_green f-12 cursor_pointer fw-bold text-decoration-underline'  onClick={() => this.voterWiseVisitCaptureClick(row)}>Which Party Voted</h6>
                        <h6 className='color_green f-12 fw-bold mt-2'>(Already Voted)</h6>
                        </>
                    )
                    :
                    (<h6 className='color_red cursor_pointer f-12 fw-bold text-decoration-underline'  onClick={() => this.voterWiseVisitCaptureClick(row)}>Which Party Voted</h6>)
                    
                }
            </>
            
              
         );
    }

    voterWiseVisitCaptureClick = (data) => {
        if(navigator.geolocation){
            navigator.geolocation.getCurrentPosition(this.checkingLocationServicePolledVoted,this.checkingLocationServiceEnabledError)
        }
    
        this.setState({
            voterVisitedImageCaptureModal:true,savaCampaignLoadingSymbol:"hide",
            answerDateTemplateArr:[],
            checkValidationsArr:[],
            checkQuestionsMessage:"",
            savaCampaignLoadingSuccessMsg:"",submitButtonDisabled:false
            });

            console.log("datadatadatadata",data)
            
            setTimeout(() => this.setState({selectedVoterVisitVoterId:data}), 1000);
      }
    

    voterSlipSendDisplayData = (data) => {
        let votersData = [];
        if(data.length>0){
            
            for (let i = 0; i < data.length; i++) {

                const Serial_No = (data[i].serialNo);
                const voter_Name = (data[i].voterName);
                const Age = (data[i].age);
                const GNR = (data[i].gender);
                const voterId = (data[i].voterId);
                const houseNo = (data[i].houseNo);
                const relectiveName = (data[i].relativeName);
                const relation = (data[i].relation);
                const voterCardNo = (data[i].voterCardNo);
                const booth = (data[i].booth);
                const party = data[i].party;
                const tehsil = data[i].tehsil;
                const town = data[i].town;
                const panchayat = data[i].panchayat;
                const boothId = data[i].boothId;
                const mobileNo = data[i].mobileNo;
                const isVoted = data[i].isVoted;
                const isSlipSent = data[i].isSlipSent;
                const isSlipGiven = data[i].isSlipGiven;
                const constituencyId = data[i].constituencyId;
                const checkedCondition = data[i].isVoted == 'Y' ?  true : false;
                const checkedConditionNo = data[i].isVoted == 'N' ?  true : false;
                const isExitPolled = data[i].isExitPolled;
                const casteId = data[i].casteId;
                const casteName = data[i].casteName;
                const isCasteUpdated = data[i].isCasteUpdated;
                
                const obj = {
                    Serial_No:(Serial_No),
                    voter_Name:voter_Name,
                    GNR: GNR,
                    Age: Age,
                    voterId: voterId,
                    houseNo:houseNo,
                    relectiveName:relectiveName,
                    relation:relation,
                    voterCardNo:voterCardNo,
                    booth:booth,
                    party:party,
                    mandal_town : tehsil != "" ? tehsil : town,
                    panchayat:panchayat,
                    boothId:boothId,
                    mobileNo:mobileNo,
                    isVoted:isVoted,
                    isSlipSent:isSlipSent,
                    isSlipGiven:isSlipGiven,
                    constituencyId:constituencyId,
                    checkedCondition:checkedCondition,
                    checkedConditionNo:checkedConditionNo,
                    isExitPolled:isExitPolled,
                    casteId:casteId,
                    casteName:casteName == "" ? "-" : casteName,
                    isCasteUpdated:isCasteUpdated
                    
                }
                votersData.push(obj);
            } 

            
            
            return votersData;
        }
    }

    handleOnchangeInputBox = (e) => {
        console.log("handleInputChange", e.target.name, e.target.value)
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value });
      }

    sendVoterSlipViaWhatsAppMessageModal = (dataObj,url) => {
        if(navigator.geolocation){
            navigator.geolocation.getCurrentPosition(this.checkingLocationServiceEnabled,this.checkingLocationServiceEnabledError)
        }

        this.setState({sendButtonDisabled:false,voterSlipLoading:"hide"})
        if(dataObj.mobileNo != ""){
            this.setState({mobileNoValue:dataObj.mobileNo})
        }
        this.setState({validateMobileNo:"" });
        this.setState({sendWhatsAppMessageModal:true,selectedVoterObj:dataObj,messageUrl:url});
    }

    checkingLocationServiceEnabled = (position) => {
        const getCoordinates =  
            { 
            "latitude" : position.coords.latitude,
            "longitude" : position.coords.longitude,
            "accuracy":position.coords.accuracy
            }
            
        this.setState({checkingLocationServiceEnabledObj:getCoordinates});
    }
    

    checkingLocationServiceEnabledError = (error) => {
      return(
        <EnabledLocationPopup 
                show={() => this.setState({ checkingEnabledLocationModal: true })}
                onHide={() => this.setState({ checkingEnabledLocationModal: false })}
                closeEnabledModal={this.closeEnabledModal}
         />
      )
        
    }

    closeEnabledModal = () => {
        this.props.history.push({
            pathname: "/send_voter_slip",
            params: {
                navbarDisplay:"show",
                userAccessList:this.state.userAccessList,
            
            },
        });
        
    }

    
    sendVoterSlipViaWhatsAppMessage = () => {
        this.setState({validateMobileNo:"" });

        if(this.state.mobileNoValue == ""){
            this.setState({validateMobileNo:"Please Enter Mobile No" });
            return;
        }
        if(!this.state.mobileNoValue.match(/^[0-9]+$/)){
            this.setState({validateMobileNo:"Please Enter Valid Mobile No"});
            return;
        }
    
        if(this.state.mobileNoValue.length < 10){
            this.setState({validateMobileNo:"Please Enter Valid Mobile No"});
            return;
        }

        const obj =  
        JSON.stringify({ 
            "chatId" :this.state.chatID,
            "mobileNo" : this.state.mobileNoValue,
            "voterId" : this.state.selectedVoterObj.voterId,
            "latitude":this.state.checkingLocationServiceEnabledObj.latitude,
            "longitude":this.state.checkingLocationServiceEnabledObj.longitude,
        });
        
        this.setState({voterSlipLoading:"show",sendButtonDisabled:true}); 
    
        getAPICallData(obj,this.state.messageUrl)
        .then((res) => res.json())
        .then((content) => {
            this.setState({voterSlipLoading:"hide"});  
    
            if(content !=null && content.status == "Success"){
                this.setState({voterSlipMessage:"Voter Slip Send SuccessFully..."});
                this.change_status_SlipSent(this.state.voterDetailsInABoothArr) 
                 setTimeout(() => {
                    this.setState({sendWhatsAppMessageModal:false});
                    this.setState({voterSlipMessage:""});
                    this.setState({sendButtonDisabled:false})
    
                }, 1000);
            }else if(content !=null && content.status == "Fail"){
                this.setState({voterSlipMessage:content.message});
                
        
            }else{
                this.setState({voterSlipMessage:"Some Thing Went Wrong,Please Try Again..."});
        
            }
        });
}

change_status_SlipSent = (_data) => {
    for(var key in _data){
        if(_data[key].voterId == this.state.selectedVoterObj.voterId){
            
            _data[key].isSlipSent = 'Y'
            

        }
    }
    console.log("_data",_data) ;
    this.setState({voterDetailsInABoothArr:_data});
}


handlesearchVoterDetails = (event) => {
    this.setState({
        searchVoterDetailsValue: event.target.value
    })
}

handleMultipleSelectInputChange = async (e, name) => {
    console.log("eeeee", e,name);
    
    let etesttype = Array();
    let etesttypevalue = Array();
    if (e != null && e.length > 0) {
        for (let i = 0; i < e.length; i++) {
            const etesttypeval = e[i];
            const newObj = {
                label: etesttypeval.label,
                value: etesttypeval.value
            }
            etesttypevalue.push(newObj);
            etesttype.push(etesttypeval.value);
        }
        this.setState({
            partyseldata: etesttypevalue,
            partyselvalue: etesttype,
            
        });
    }else{
        this.setState({
            partyseldata: [],
            partyselvalue: [],
            
        }); 
    }
};



voterCasteUpdateModal = (data) => {
    this.setState({casteIdStr:"", casteIdStrValue:""});
    this.setState({updateVoterCasteMessage:"",disabledButtonCaste:false});
   
    if(data.casteId !=""){
        let casteIdName = this.state.caste_ids_Arr.find((a) => a.value == data.casteId);
            this.setState({
                casteIdStrValue: {
                value: casteIdName.value,
                label: casteIdName.label
            },casteIdStr:data.casteId
        });
    }
    this.setState({UpdateVoterCasteModalShow:true,selectedVoterCasteIds:data});
}


updateVoterCaste = () => {
    var casteStateId="";
    
    if(this.state.casteIdStr == ""){
        casteStateId = this.state.selectedVoterCasteIds.casteId
    }else{
        casteStateId = this.state.casteIdStr
    }

    this.setState({validateCasteName:"" });
    if(casteStateId == ""){
        this.setState({validateCasteName:"Please Select Caste" });
        return;
    }
    
    this.setState({disabledButtonCaste:true,updateVoterCasteLoading:"show"});
    

    
    const obj =  
    JSON.stringify({ 
        "chatId" :this.state.chatID,
        "voterId" : this.state.selectedVoterCasteIds.voterId,
        "casteStateId" : casteStateId
    });

    getAPICallData(obj,"updateVoterCaste")
    .then((res) => res.json())
    .then((content) => {
        this.setState({updateVoterCasteLoading:"hide"})
        if(content !=null && content.status == "Success"){
            this.setState({updateVoterCasteMessage:"Updated SuccessFully..."});
            this.change_status_casteUpdated(this.state.voterDetailsInABoothArr) 
            setTimeout(() => {
                this.setState({UpdateVoterCasteModalShow:false});
                this.setState({updateVoterCasteMessage:"",disabledButtonCaste:false});
            }, 1000);

        }else if(content !=null && content.status == "Fail" && content.message == "Authentication Failed"){
            this.setState({updateVoterCasteMessage:"Session Expire...Please Close Then Open Telegram Bot"});
        }else if(content !=null && content.status == "Fail"){
            this.setState({updateVoterCasteMessage:content.message});
        }else{
            this.setState({updateVoterCasteMessage:"Some Thing Went Wrong,Please Try Again..."});
        }
    });
}


change_status_casteUpdated = (_data) => {
    for(var key in _data){
        if(_data[key].voterId == this.state.selectedVoterCasteIds.voterId){
            
            _data[key].isCasteUpdated = 'Y'
            _data[key].casteName = this.state.casteIdStrValue.label
            

        }
    }
    console.log("_data",_data) ;
    this.setState({voterDetailsInABoothArr:_data});
}

updateVoterPollingStatus = (e,voterId,isVoted) => {
    var isVotedVal=isVoted;

    var loadingSymbolCls = "loadingSymbolIsVoted"+voterId+"";
    var messageDisplay = "messageDisplay"+voterId+"";

    document.getElementById(loadingSymbolCls).innerHTML = "";
    document.getElementById(messageDisplay).innerHTML = "";

    /*if (e?.target?.checked == true) {
        isVotedVal = 'Y'
    }else{
        isVotedVal = 'N'
    }*/

    const obj =  
    JSON.stringify({ 
        "chatId" :this.state.chatID,
        "isVoted" : isVotedVal,
        "voterId" : voterId
    });

    document.getElementById(loadingSymbolCls).innerHTML = "loading...";
    

    getAPICallData(obj,"updateVoterPollingStatus")
    .then((res) => res.json())
    .then((content) => {
        document.getElementById(loadingSymbolCls).innerHTML = "";  

        if(content !=null && content.status == "Success"){
            if(isVotedVal == ''){
                document.getElementById(messageDisplay).innerHTML = "Vote Is canceled";
            }else{
                document.getElementById(messageDisplay).innerHTML = "Vote Updated";
            }
            


        }else if(content !=null && content.status == "Fail" && content.message == "Authentication Failed"){
            document.getElementById(messageDisplay).innerHTML = "Session Expire...Please Close Then Open Telegram Bot";
        }else if(content !=null && content.status == "Fail"){
            document.getElementById(messageDisplay).innerHTML = content.message;
    
        }else{
            document.getElementById(messageDisplay).innerHTML = "Some Thing Went Wrong,Please Try Again...";
    
        }
    });
}

updateVoterSlipGivenStatus = (e,voterId,isVoted) => {
    var isSlipGiven="";

    var loadingSymbolCls = "loadingSymbolIsGivenVoted"+voterId+"";
    var messageDisplay = "messageDisplayGiven"+voterId+"";

    document.getElementById(loadingSymbolCls).innerHTML = "";
    document.getElementById(messageDisplay).innerHTML = "";

    if (e?.target?.checked == true) {
        isSlipGiven = 'Y'
    }else{
        isSlipGiven = 'N'
    }

    const obj =  
    JSON.stringify({ 
        "chatId" :this.state.chatID,
        "isSlipGiven" : isSlipGiven,
        "voterId" : voterId
    });

    document.getElementById(loadingSymbolCls).innerHTML = "loading...";
    

    getAPICallData(obj,"updateVoterSlipGivenStatus")
    .then((res) => res.json())
    .then((content) => {
        document.getElementById(loadingSymbolCls).innerHTML = "";  

        if(content !=null && content.status == "Success"){
            document.getElementById(messageDisplay).innerHTML = "Slip Given";
        }else if(content !=null && content.status == "Fail"){
            document.getElementById(messageDisplay).innerHTML = content.message;
    
        }else{
            document.getElementById(messageDisplay).innerHTML = "Some Thing Went Wrong,Please Try Again...";
    
        }
    });
}

 
getOnchangeSelectedKPIAnswer = (e,data,mainlist) => {
    const name = e.target.name;
    const value = e.target.value;

    var newItem = {};
    var tempArr = this.state.answerDateTemplateArr;

    this.setState({checkQuestionsMessage:""});
    for(var i in this.state.campaignSurveyQuestionnaireArr){
        var errorQuestion = "errorMsgDisplay"+this.state.campaignSurveyQuestionnaireArr[i].questionId+"";
        document.getElementById(errorQuestion).innerHTML = "";
    }

    const objWithIdIndex = tempArr.findIndex((obj) => obj.questionId == mainlist.questionId);

    if (objWithIdIndex > -1) {
        tempArr.splice(objWithIdIndex, 1);
        this.setState({answerTemplateArr:tempArr})
    }


    if (mainlist.answerType == "Single Option") {
        newItem = {
            campaignSurveyId:mainlist.campaignSurveyId,
            questionId: mainlist.questionId,
            optionId: value, 
        };
    }else if(mainlist.answerType == "Number"){
        newItem = {
            campaignSurveyId:mainlist.campaignSurveyId,
            questionId: mainlist.questionId,
            answerNumber: value, 
        };
    }else if(mainlist.answerType == "Text"){
        newItem = {
            campaignSurveyId:mainlist.campaignSurveyId,
            questionId: mainlist.questionId,
            answerText: value, 
        };
    }else if(mainlist.answerType == "Percentage"){
        newItem = {
            campaignSurveyId:mainlist.campaignSurveyId,
            questionId: mainlist.questionId,
            answerPercentage: value, 
        };
    }else if(mainlist.answerType == "Multi Option"){
        newItem = {
            campaignSurveyId:mainlist.campaignSurveyId,
            questionId: mainlist.questionId,
            optionId: value, 
        };
    }

    this.setState({answerDateTemplateArr:[...this.state.answerDateTemplateArr, newItem]}); 
}

checkingLocationServicePolledVoted = (position) => {
    const getCoordinates =  
        { 
        "latitude" : position.coords.latitude,
        "longitude" : position.coords.longitude,
        "accuracy":position.coords.accuracy
        }
        
    this.setState({checkingLocationServiceVoterObj:getCoordinates});
}


saveCampaignEnrollment = () => {

    let finalMergeKPIAnswerDts = this.state.answerDateTemplateArr;

    for(var i in this.state.campaignSurveyQuestionnaireArr){
        var errorQuestion = "errorMsgDisplay"+this.state.campaignSurveyQuestionnaireArr[i].questionId+"";
            document.getElementById(errorQuestion).innerHTML = "";
    }

        const validationsArr =  this.state.campaignSurveyQuestionnaireArr.filter(item => !finalMergeKPIAnswerDts.some(finalMergeKPIAnswerDts => finalMergeKPIAnswerDts.questionId == item.questionId))
        this.setState({checkValidationsArr:validationsArr})  

        if(validationsArr.length > 0){
            this.setState({checkQuestionsMessage:"Please Answer All Questions In Above Block"})
            for(var i in validationsArr){
                var errorQuestion = "errorMsgDisplay"+validationsArr[i].questionId+"";
                
                if(validationsArr[i].answerType == "Single Option"){
                    document.getElementById(errorQuestion).innerHTML = "Please Check Option";
                    return;
                }else if(validationsArr[i].answerType == "Multi Option"){
                    document.getElementById(errorQuestion).innerHTML = "Please Check Atleast one Option";
                    return;
                }else if(validationsArr[i].answerType == "Number"){
                    document.getElementById(errorQuestion).innerHTML = "Please Enter Number";
                    return;
                }else if(validationsArr[i].answerType == "Text"){
                    document.getElementById(errorQuestion).innerHTML = "Please Enter Text";
                    return;
                }else if(validationsArr[i].answerType == "Percentage"){
                    document.getElementById(errorQuestion).innerHTML = "Please Enter Percentage";
                    return;
                }
                
            }
            
        }

    this.setState({savaCampaignLoadingSymbol:"show",submitButtonDisabled:true});   

    const obj =  
    JSON.stringify({ 
        "chatId" :this.state.chatID,
        "mobileNo" : this.state.selectedVoterVisitVoterId.mobileNo,
        "campaignId" : 6,
        "voterName" : this.state.selectedVoterVisitVoterId.voter_Name,
        "voterId" : this.state.selectedVoterVisitVoterId.voterId,
        "gender" : this.state.selectedVoterVisitVoterId.GNR,
        "age" : this.state.selectedVoterVisitVoterId.Age,
        "houseId" : "",
        "boothId" : this.state.selectedVoterVisitVoterId.boothId,
        "constituencyId" : this.state.selectedVoterVisitVoterId.constituencyId,
        "latitude":this.state.checkingLocationServiceVoterObj.latitude,
        "longitude":this.state.checkingLocationServiceVoterObj.longitude,
        "base64StrList" : [],
        "answerList":finalMergeKPIAnswerDts
    });
    
    

getAPICallData(obj,"CampaignEnrollment/saveCampaignEnrollmentNew")
    .then((res) => res.json())
    .then((content) => {
        this.setState({savaCampaignLoadingSymbol:"hide"});  

        if(content !=null && content.status == "Success"){
            
            
           /* const checkedVoterDetailsArr = this.state.voterDetailsInABoothArr.map((item) => {
                if (item.voterId == this.state.selectedVoterVisitVoterId.voterId) {
                    return { ...item, isVoted:'Y',isExitPolled:'Y' }
                }
                return { ...item }
            });
    
            this.setState({voterDetailsInABoothArr:checkedVoterDetailsArr});*/

            
            this.setState({savaCampaignLoadingSuccessMsg:"Vote Polled..."});
           
             setTimeout(() => {
                this.updateVoterPollingStatusByOptionClick(this.state.selectedVoterVisitVoterId.voterId);
                this.setState({voterVisitedImageCaptureModal:false});
                this.setState({savaCampaignLoadingSuccessMsg:"",submitButtonDisabled:false});
            }, 1000);
        }else if(content !=null && content.status == "Fail" && content.message == "This House is Already Registered"){
            this.setState({savaCampaignLoadingSuccessMsg:"This Voter is Already Voted"});
        }else if(content !=null && content.status == "Fail" && content.message == "Authentication Failed"){
            this.setState({savaCampaignLoadingSuccessMsg:"Session Expire...Please Close Then Open Telegram Bot"});
        }else if(content !=null && content.status == "Fail"){
            this.setState({savaCampaignLoadingSuccessMsg:content.message});
    
        }else{
            this.setState({savaCampaignLoadingSuccessMsg:"Some Thing Went Wrong,Please Try Again..."});
    
        }
    });
}

updateVoterPollingStatusByOptionClick = (voterId) => {

    var messageDisplay = "messageDisplay"+voterId+"";

    document.getElementById(messageDisplay).innerHTML = "";

   
    const obj =  
    JSON.stringify({ 
        "chatId" :this.state.chatID,
        "isVoted" : 'Y',
        "voterId" : voterId
    });

    //document.getElementById(loadingSymbolCls).innerHTML = "loading...";
    

    getAPICallData(obj,"updateVoterPollingStatus")
    .then((res) => res.json())
    .then((content) => {
        //document.getElementById(loadingSymbolCls).innerHTML = "";  

        if(content !=null && content.status == "Success"){
            const checkedVoterDetailsArr = this.state.voterDetailsInABoothArr.map((item) => {
                if (item.voterId == voterId) {
                    return { ...item, isVoted:'Y',isExitPolled:'Y'}
                }
                return { ...item }
            });
    
            this.setState({voterDetailsInABoothArr:checkedVoterDetailsArr});
           
           // document.getElementById(messageDisplay).innerHTML = "Vote Updated";
        }else if(content !=null && content.status == "Fail"){
           // document.getElementById(messageDisplay).innerHTML = content.message;
        }else{
            //document.getElementById(messageDisplay).innerHTML = "Some Thing Went Wrong,Please Try Again...";
    
        }
    });
}

    
    
    render() {
        let voterSlipDetailsArr=[];
        let keyword = this.state.searchVoterDetailsValue.toString()
        if (keyword !== ''){
            voterSlipDetailsArr = this.state.voterDetailsInABoothArr.filter(  (item) => {
                
                if (item.voterCardNo.toLowerCase().startsWith(keyword.toLowerCase())) {
                    return item;
                }
                if (item.serialNo.toString().startsWith(keyword.toLowerCase())) {
                    return item;
                }
                if (item.voterName.toLowerCase().includes(keyword.toLowerCase())) {
                    return item;
                }
                if (item.gender.toLowerCase().includes(keyword.toLowerCase())) {
                    return item;
                }
                if (item.age.toString().startsWith(keyword.toLowerCase())) {
                    return item;
                }
                if (item.relativeName.toLowerCase().includes(keyword.toLowerCase())) {
                    return item;
                }
                if (item.relation.toLowerCase().includes(keyword.toLowerCase())) {
                    return item;
                }
                if (item.houseNo.toString().startsWith(keyword.toLowerCase())) {
                    return item;
                }
                if (item.booth.toString().startsWith(keyword.toLowerCase())) {
                    return item;
                }
                if (item.mobileNo.toString().startsWith(keyword.toLowerCase())) {
                    return item;
                }
                if (item.party.toLowerCase().includes(keyword.toLowerCase())) {
                    return item;
                }
                if (item.panchayat.toLowerCase().includes(keyword.toLowerCase())) {
                    return item;
                }
                
            } );


        }else{
            voterSlipDetailsArr = this.state.voterDetailsInABoothArr;
            
        }

        let partyselectall = true;
        let partylabelledBY = "ALL";
        let partydisablesearch = false;
        if (this.state.partyIdsArr.length > 0) {
            partyselectall = true;
            partydisablesearch = false;
        }
        else {
            partydisablesearch = true;
            partyselectall = false;
            partylabelledBY = "No Options"
        }

        return (
            <section>
                <Container fluid>
                    <>
                    <Row>
                        <Col>
                            <h6 className='fw-bold text-center text-uppercase'> Voter Slip & Poll Management</h6>
                        </Col>
                    </Row>
                    {
                        this.state.chatID != "1048868711" ?
                        (
                            this.state.delaylocationModal == true && Object.keys(this.state.checkingLocationServiceEnabledPopupObj).length == 0 ?
                            (
                                <EnabledLocationPopup 
                                    show={() => this.setState({ checkingEnabledLocationModal: true })}
                                    onHide={() => this.setState({ checkingEnabledLocationModal: false })}
                                    closeEnabledModal={this.closeEnabledModal}
                                />
                             )
                            :
                            ("")
                        )
                        :
                        ("")
                    }
                    
                    <Row>
                        <Col className='w_80'>
                            <h6 className="form-label f-12 fw-bold">Booth<span className='color_red f-14 ms-1'>*</span> <span className='color_red f-12'>{this.state.validateboothId}</span></h6>
                                <SelectBox
                                    stateData={this.state.boothIdValue}
                                    handleChange={this.handleOnchangeSelectBoxNew}
                                    name="boothId"
                                    options={this.state.boothIdsList}
                                    placeholderName={'Select Booth'}
                                    dropdownIndicator={{ DropdownIndicator }}
                                />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                           <Form.Group className="mt-2" controlId="formNameId">
                               <Form.Label className='f-12 fw-bold'>Voter Name </Form.Label>
                               <Form.Control type="text" name="voterName" className='form-control-sm'  placeholder="Enter Name" onChange={(e) => this.handleOnchangeInputBox(e)}/>
                           </Form.Group>    
                       </Col>
                        <Col>
                            <Form.Group className="mt-2" controlId="formVoterSerachCardNoId">
                                <Form.Label className='f-12 fw-bold'>Voter Card No </Form.Label>
                                <Form.Control type="text" name="voterCardNo" className='form-control-sm'  placeholder="Enter Voter Card No" onChange={(e) => this.handleOnchangeInputBox(e)}/>
                            </Form.Group>    
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                           <Form.Group className="mt-2" controlId="formNameId">
                               <Form.Label className='f-12 fw-bold'>House No </Form.Label>
                               <Form.Control type="text" name="houseNo" className='form-control-sm'  placeholder="Enter Name" onChange={(e) => this.handleOnchangeInputBox(e)}/>
                           </Form.Group>    
                       </Col>
                        {/*<Col>
                            <Form.Group className="mt-2" controlId="formVoterSerachCardNoId">
                                <Form.Label className='f-12 fw-bold'>Party </Form.Label>
                                
                                <MultiSelect
                                    overrideStrings={{
                                        "allItemsAreSelected": "All",
                                        "selectSomeItems": partylabelledBY
                                    }}
                                    hasSelectAll={partyselectall}
                                    options={this.state.partyIdsArr}
                                    disableSearch={partydisablesearch}
                                    value={this.state.partyseldata}
                                    onChange={(e) => this.handleMultipleSelectInputChange(e, "party")}
                                    labelledBy={"Select"}
                                    className="f-14 color_black"
                                /> 
                            </Form.Group>    
                                </Col>*/}
                   </Row>

                   <Row>
                        <Col>
                            <Form>
                                
                                <div className='mt-3'>
                                <span className='f-14 fw-bold pos_left_cs'>Is Voted : </span>
                                <Form.Check
                                    inline
                                    label={`All`}
                                    name="enrolledName"
                                    type="radio"
                                    id={`allenrolledId`}
                                    onChange={(e)=>this.checkIsVoterSearch(e,"")}
                                    className="f-14 fw-bold color_black"
                                    value=""
                                    
                                />
                                <Form.Check
                                    inline
                                    label={`Voted`}
                                    name="enrolledName"
                                    type="radio"
                                    id={`enrolledId`}
                                    onChange={(e)=>this.checkIsVoterSearch(e,"Y")}
                                    className="f-14 fw-bold color_black"
                                    value="Y"
                                />
                                <Form.Check
                                    inline
                                    label={`Not Voted`}
                                    name="enrolledName"
                                    type="radio"
                                    id={`notEnrolledId`}
                                    onChange={(e)=>this.checkIsVoterSearch(e,"N")}
                                    className="f-14 fw-bold color_black"
                                    value="N"
                                    defaultChecked={true}
                                    
                                />
                                </div>
                            </Form>   
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <Form>
                                
                                <div className='mt-2'>
                                <span className='f-14 fw-bold pos_left_cs'>Is Caste Assigned : </span>
                                <Form.Check
                                    inline
                                    label={`All`}
                                    name="isCasteAssigned"
                                    type="radio"
                                    id={`allcasteAssignedId`}
                                    onChange={(e)=>this.checkIsCasteAssigned(e,"")}
                                    className="f-14 fw-bold color_black"
                                    value=""
                                    defaultChecked={true}
                                />
                                <Form.Check
                                    inline
                                    label={`Yes`}
                                    name="isCasteAssigned"
                                    type="radio"
                                    id={`yescasteAssignedId`}
                                    onChange={(e)=>this.checkIsCasteAssigned(e,"Y")}
                                    className="f-14 fw-bold color_black"
                                    value="Y"
                                />
                                <Form.Check
                                    inline
                                    label={`No`}
                                    name="isCasteAssigned"
                                    type="radio"
                                    id={`nocasteAssignedId`}
                                    onChange={(e)=>this.checkIsCasteAssigned(e,"N")}
                                    className="f-14 fw-bold color_black"
                                    value="N"
                                    
                                />
                                </div>
                            </Form>   
                        </Col>
                            </Row>

                    <Row>
                        <Col>
                            <Form>
                                
                                <div className='mt-2'>
                                <span className='f-14 fw-bold pos_left_cs'>Is Caste Updated : </span>
                                <Form.Check
                                    inline
                                    label={`All`}
                                    name="isCasteUpdated"
                                    type="radio"
                                    id={`allcasteUpdatedId`}
                                    onChange={(e)=>this.checkIsCasteUpdated(e,"")}
                                    className="f-14 fw-bold color_black"
                                    value=""
                                    defaultChecked={true}
                                />
                                <Form.Check
                                    inline
                                    label={`Yes`}
                                    name="isCasteUpdated"
                                    type="radio"
                                    id={`yescasteUpdatedId`}
                                    onChange={(e)=>this.checkIsCasteUpdated(e,"Y")}
                                    className="f-14 fw-bold color_black"
                                    value="Y"
                                />
                                <Form.Check
                                    inline
                                    label={`No`}
                                    name="isCasteUpdated"
                                    type="radio"
                                    id={`nocasteUpdatedId`}
                                    onChange={(e)=>this.checkIsCasteUpdated(e,"N")}
                                    className="f-14 fw-bold color_black"
                                    value="N"
                                    
                                />
                                </div>
                            </Form>   
                        </Col>
                    </Row>

                    {/*<Row>
                        <Col>
                            <Form>
                                
                                <div className='mt-3'>
                                <span className='f-14 fw-bold pos_left_cs'>Is Voter Slip Sent : </span>
                                <Form.Check
                                    inline
                                    label={`All`}
                                    name="isVoterSlipSent"
                                    type="radio"
                                    id={`allvoterSlipId`}
                                    onChange={(e)=>this.checkIsVoterSlipSent(e,"")}
                                    className="f-14 fw-bold color_black"
                                    value=""
                                    defaultChecked={true}
                                />
                                <Form.Check
                                    inline
                                    label={`Yes`}
                                    name="isVoterSlipSent"
                                    type="radio"
                                    id={`yesvoterSlipId`}
                                    onChange={(e)=>this.checkIsVoterSlipSent(e,"Y")}
                                    className="f-14 fw-bold color_black"
                                    value="Y"
                                />
                                <Form.Check
                                    inline
                                    label={`No`}
                                    name="isVoterSlipSent"
                                    type="radio"
                                    id={`novoterSlipId`}
                                    onChange={(e)=>this.checkIsVoterSlipSent(e,"N")}
                                    className="f-14 fw-bold color_black"
                                    value="N"
                                    
                                />
                                </div>
                            </Form>   
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <Form>
                                
                                <div className='mt-3'>
                                <span className='f-14 fw-bold pos_left_cs'>Voter Slip Given : </span>
                                <Form.Check
                                    inline
                                    label={`All`}
                                    name="isGivenSlipSent"
                                    type="radio"
                                    id={`allgivenSlipId`}
                                    onChange={(e)=>this.checkIsVoterSlipGivenSent(e,"")}
                                    className="f-14 fw-bold color_black"
                                    value=""
                                    defaultChecked={true}
                                />
                                <Form.Check
                                    inline
                                    label={`Yes`}
                                    name="isGivenSlipSent"
                                    type="radio"
                                    id={`yesgivenSlipId`}
                                    onChange={(e)=>this.checkIsVoterSlipGivenSent(e,"Y")}
                                    className="f-14 fw-bold color_black"
                                    value="Y"
                                />
                                <Form.Check
                                    inline
                                    label={`No`}
                                    name="isGivenSlipSent"
                                    type="radio"
                                    id={`nogivenSlipId`}
                                    onChange={(e)=>this.checkIsVoterSlipGivenSent(e,"N")}
                                    className="f-14 fw-bold color_black"
                                    value="N"
                                    
                                />
                                </div>
                            </Form>   
                        </Col>
                                </Row>*/}
                  
                    
                    <Row>
                        <Col>
                            <Button variant="dark" className='f-12 center-auto mt-3' onClick={() => this.getVoterDetailsInABooth()}>GET VOTERS</Button> 
                           
                        </Col>
                    </Row>

                    {
                        this.state.votersListSlipLoader == "show" ?
                        (
                            <Row>
                                <Col sm={12}>
                                    <div class="spinner-border color_yellow loading-img-center mt-4"></div>
                                </Col>
                            </Row>
                        )
                        :
                        ("")
                    }
                    {
                        this.state.voterDetailsInABoothArr.length>0 ?
                        (
                            
                            <>
                            <Row>
                                <Col sm={12}>
                                <div className='bg_light_blue mt-3'>
                                    <Row>
                                        <Col sm={6}>
                                            <input
                                                className='float-end search_bar mt-2'
                                                type="search"
                                                placeholder='Search'
                                                value={this.state.searchVoterDetailsValue}
                                                onChange={this.handlesearchVoterDetails}
                                            />
                                            <i className='fa fa-search search-icon'></i>
                                        </Col>
                                    </Row>
                                

                                    {
                                        voterSlipDetailsArr.length>0 ?
                                        (
                                            
                                        
                                            <CardLessDataTableWithOutSearch 
                                                    parentData={this.voterSlipSendDisplayData(voterSlipDetailsArr)}
                                                    particlecolumns={this.voterSlipSendDisplayColumns()}
                                                    defaultSorted={[{
                                                        dataField: "Serial_No",
                                                        order: "asc"
                                                    }]}
                                                    tableHeading="Voters Details"
                                                    />        
                                                                
                                            
                                        )
                                        :
                                        (<h6 className='f-14 text-center mt-4'>No Data Availble...</h6>)
                                        }
                                    
                                        
                                </div>
                                
                                </Col>
                            </Row>
                            </>
                        )
                        :
                        (<>
                            {
                            this.state.votersDataCheckSlip == 1 ?
                            (<h6 className='f-14 text-center mt-4'>No Data Availble.....</h6>)
                            :
                            (
                                this.state.votersDataCheckSlip == 2 ? 
                                (<h6 className='f-14 text-center mt-4'>Session Expire...Please Close Then Open Telegram Bot</h6>)
                                :
                                ("")
                            )
                        }
                        </>)
                    }


                       
                    </>

                    <SendWhatsAppMessage 
                        show={this.state.sendWhatsAppMessageModal}
                        onHide={() => this.setState({ sendWhatsAppMessageModal: false })}
                        stateData={this.state}
                        handleOnchangeInputBox={this.handleOnchangeInputBox}
                        sendVoterSlipViaWhatsAppMessage={this.sendVoterSlipViaWhatsAppMessage}
                    />

                    <QuestionsSavingPoll
                        show={this.state.voterVisitedImageCaptureModal}
                        onHide={() => this.setState({ voterVisitedImageCaptureModal: false })}
                        stateData={this.state}
                        saveCampaignEnrollment={this.saveCampaignEnrollment}
                        handleOnchangeInputBox={this.handleOnchangeInputBox}
                        getOnchangeSelectedKPIAnswer={this.getOnchangeSelectedKPIAnswer}
                />
                <UpdateVoterCaste
                        show={this.state.UpdateVoterCasteModalShow}
                        onHide={() => this.setState({ UpdateVoterCasteModalShow: false })}
                        stateData={this.state}
                        updateVoterCaste={this.updateVoterCaste}
                        handleOnchangeSelectBoxNew={this.handleOnchangeSelectBoxNew}
                />

                </Container>
                
            </section>   
        )
    }
  }
  
  export default withRouter(SendVoterSlipSection);
  